import { jquery } from 'jquery';
import $ from 'jquery';

export default class BgLight {
    constructor() {
        this.init();
    }

    init() {
        this.glitter();
    }

    glitter() {
        // 星S
        const glitterEls = document.querySelectorAll('.js-glitter');
        const glitterElsArr = Array.prototype.slice.call(glitterEls);

        glitterElsArr.forEach((glitterEl) => {
            let interval;

            window.addEventListener('DOMContentLoaded', () => {
                interval = setInterval(createStar.bind(undefined, glitterEl), 400);
            });
        });

        // 星F
        const glitterFEls = document.querySelectorAll('.js-glitter-f');
        const glitterFElsArr = Array.prototype.slice.call(glitterFEls);

        glitterFElsArr.forEach((glitterFEl) => {
            let interval;

            window.addEventListener('DOMContentLoaded', () => {
                interval = setInterval(createStarF.bind(undefined, glitterFEl), 600);
            });
        });

        // 流れ星S
        const glitterShootingstarS = document.querySelectorAll('.js-shootingstar_s');
        const glitterShootingstarSArr = Array.prototype.slice.call(glitterShootingstarS);

        glitterShootingstarSArr.forEach((glitterEl) => {
            let interval;

            window.addEventListener('DOMContentLoaded', () => {
                interval = setInterval(createShootingstarS.bind(undefined, glitterEl), 800);
            });
        });

        // 流れ星L
        const glitterShootingstarL = document.querySelectorAll('.js-shootingstar_l');
        const glitterShootingstarLArr = Array.prototype.slice.call(glitterShootingstarL);

        glitterShootingstarLArr.forEach((glitterEl) => {
            let interval;

            window.addEventListener('DOMContentLoaded', () => {
                interval = setInterval(createShootingstarL.bind(undefined, glitterEl), 800);
            });
        });

        // 星Sを生成する関数
        const createStar = (el) => {
            const starColor = ['-red', '-blue', '-green', '-orange', '-purple', '-yellow', '-yellow', '-yellow', '-yellow', '-yellow', '-yellow'];
            let starColorClass = starColor[Math.floor(Math.random() * starColor.length)];
            const starEl = document.createElement('span');

            starEl.classList.add('c-light' , starColorClass);

            starEl.style.left = Math.random() * el.clientWidth + 'px';
            starEl.style.top = Math.random() * el.clientHeight + 'px';
            el.appendChild(starEl);

            // 一定時間経つと星を消す
            setTimeout(() => {
                starEl.remove();
            }, 3000);
        };

        // 星Fを生成する関数
        const createStarF = (el) => {
            const starFEl = document.createElement('span');
            starFEl.className = 'c-light-f';
            starFEl.style.left = Math.random() * el.clientWidth + 'px';
            starFEl.style.top = Math.random() * el.clientHeight + 'px';
            el.appendChild(starFEl);

            // 一定時間経つと星を消す
            setTimeout(() => {
                starFEl.remove();
            }, 1000);
        };

        // 流れ星Sを生成する関数
        const createShootingstarS = (el) => {
            const shootingstarEl = document.createElement('span');
            const starinnerEl = document.createElement('span');
            const starlineEl = document.createElement('span');
            const starlineImgEl = document.createElement('span');
            const starlightEl = document.createElement('span');

            shootingstarEl.className = 'c-shootingstar_s';
            starinnerEl.className = 'c-shootingstar_s__inner';
            starlineEl.className = 'c-shootingstar_s__line';
            starlineImgEl.className = 'c-shootingstar_s__line__img';
            starlightEl.className = 'c-shootingstar_s__light';
            
            shootingstarEl.style.left = Math.random() * el.clientWidth + 'px';
            shootingstarEl.style.top = Math.random() * el.clientHeight + 'px';

            el.appendChild(shootingstarEl);
            shootingstarEl.insertBefore(starinnerEl, shootingstarEl.firstChild);
            starinnerEl.insertBefore(starlineEl, starinnerEl.firstChild);
            starinnerEl.insertBefore(starlightEl, starinnerEl.lastChild);
            starlineEl.insertBefore(starlineImgEl, starlineEl.lastChild);

            // 一定時間経つと星を消す
            setTimeout(() => {
                shootingstarEl.remove();
            }, 2500);
        };

        // 流れ星Lを生成する関数
        const createShootingstarL = (el) => {
            const shootingstarLEl = document.createElement('span');
            const starLinnerEl = document.createElement('span');
            const starLlineEl = document.createElement('span');
            const starLlineImgEl = document.createElement('span');
            const starLlightEl = document.createElement('span');

            shootingstarLEl.className = 'c-shootingstar_l';
            starLinnerEl.className = 'c-shootingstar_l__inner';
            starLlineEl.className = 'c-shootingstar_l__line';
            starLlineImgEl.className = 'c-shootingstar_l__line__img';
            starLlightEl.className = 'c-shootingstar_l__light';

            shootingstarLEl.style.left = Math.random() * el.clientWidth + 'px';
            shootingstarLEl.style.top = Math.random() * el.clientHeight + 'px';

            el.appendChild(shootingstarLEl);
            shootingstarLEl.insertBefore(starLinnerEl, shootingstarLEl.firstChild);
            starLinnerEl.insertBefore(starLlineEl, starLinnerEl.firstChild);
            starLinnerEl.insertBefore(starLlightEl, starLinnerEl.lastChild);
            starLlineEl.insertBefore(starLlineImgEl, starLlineEl.lastChild);

            // 一定時間経つと星を消す
            setTimeout(() => {
                shootingstarLEl.remove();
            }, 2500);
        };
    }
}

